import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { AddThreeSixtyReviewPopupComponent } from '../add-three-sixty-review-popup/add-three-sixty-review-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { retry } from 'rxjs';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-three-sixty-degree-popups',
  templateUrl: './three-sixty-degree-popups.component.html',
  styleUrls: ['./three-sixty-degree-popups.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ThreeSixtyDegreePopupsComponent implements OnInit {
  buttonColorName: any
  PopupName: any
  employeeTablePageCount: any = 25;
  CreateEmailDescription: any = `
  Dear Employee name, 
  <br /> <br />
  I hope this message finds you well. 
  <br /><br />
  I wanted to take a moment to extend my warmest wishes to you on [specific occasion or reason, e.g., your work anniversary, your recent promotion, your birthday]. It’s a pleasure to work with someone as dedicated and talented as you, and I wanted to let you know how much your contributions are valued. 
  <br /><br />
  [Include any additional personal note or well-wishing relevant to the occasion.] 
  <br /><br />
  Wishing you continued success and happiness. 
  <br /><br />
  Best regards, 
  <br /><br />
  [Your Full Name] 
  <br />[Your Designation]`;

  submissionEmail: any = `
  Dear Employee name, 
  <br /> <br />
  I hope this message finds you well. 
  <br /><br />
  I wanted to take a moment to extend my warmest wishes to you on [specific occasion or reason, e.g., your work anniversary, your recent promotion, your birthday]. It’s a pleasure to work with someone as dedicated and talented as you, and I wanted to let you know how much your contributions are valued. 
  <br /><br />
  [Include any additional personal note or well-wishing relevant to the occasion.] 
  <br /><br />
  Wishing you continued success and happiness. 
  <br /><br />
  Best regards, 
  <br /><br />
  [Your Full Name] 
  <br />[Your Designation]`;
  createSurveyForm: FormGroup = new FormGroup({});

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter Email here...',
    defaultParagraphSeparator: '',
  }
  minDate = new Date();
  selectedYear: any;
  loggedInUserCompanyID: any;

  tableData = [
    {
      function: 'A',
      band: 'A',
      rows: [
        {
          competency: 'Problem Solving',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Excel',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Communication',
          questions: [''],
          type: '',
          hasMinus: false,
        },
      ],
    },
    {
      function: 'IT',
      band: 'B',
      rows: [
        {
          competency: 'Problem Solving',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Excel',
          questions: [''],
          type: '',
          hasMinus: false,
        },
        {
          competency: 'Communication',
          questions: [''],
          type: '',
          hasMinus: false,
        },
      ],
    },
  ];
  selectedEmployees: any = [];
  stakeholderIdentificationArray: any = [];
  dropdownSettings: IDropdownSettings = {};
  stakeHoldersArrayForSetup: any = [];
  subordinateWeightage: any = null;
  superiorWeightage: any = null;
  selfWeightage: any = null;
  peerWeightage: any = null;
  externalCustomerWeightage: any = null;
  internalCustomerWeightage: any = null;
  selectedReviewID: any;
  getCompetencyList: any = []
  isExternalCustomerEnabled:boolean=false;
  isPublished:boolean=false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ThreeSixtyDegreePopupsComponent>,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe, public dialog: MatDialog,
    public toastr: ToastrService) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.PopupName = this.data.popupName;
    this.selectedYear = this.data?.selectedYear;
    this.selectedEmployees = this.data?.selectedEmployees;
    this.stakeHoldersArrayForSetup = this.data?.stakeHoldersArrayForSetup;
    this.selectedReviewID = this.data?.selectedReviewID;
    this.stakeholdersArray = this.data?.stakeholdersArray;
    this.subordinateWeightage = this.data?.subordinateWeightage;
    this.superiorWeightage = this.data?.superiorWeightage;
    this.selfWeightage = this.data?.selfWeightage;
    this.peerWeightage = this.data?.peerWeightage;
    this.externalCustomerWeightage = this.data?.externalCustomerWeightage;
    this.internalCustomerWeightage = this.data?.internalCustomerWeightage;
    this.getCompetencyList = this.data?.getCompetencyList;
    this.isExternalCustomerEnabled = this.data?.isExternalCustomerEnabled;
    this.isPublished = this.data?.isPublished;
    this.initilaizeAddSurveyForm();
    this.getAllEmployeeDropdownByCompanyID();
    if (this.PopupName == 'Create Question') {
      if (this.getCompetencyList.length == 0) {
        this.getCompetencyFor360()
      } else {

      }
    }
  }
  initilaizeAddSurveyForm() {
    this.createSurveyForm = this.fb.group({
      review360Name: [null, Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
  createSurvey() {
    
    const test = this.selectedYear?.split('-');
    if (this.createSurveyForm.valid) {
      this.closeDialog();
      const request = {
        "band": [],
        "companyId": this.loggedInUserCompanyID,
        "competencies": [],
        "department": [],
        "employee": [],
        "endDate": this.datePipe.transform(this.createSurveyForm.value.endDate, "yyyy-MM-dd"),
        "externalCustomerWeightage": null,
        "fromYear": test[0],
        "grade": [],
        "id": null,
        "instruction": [],
        "internalCustomerWeightage": null,
        "invitationEmailBody": null,
        "invitationEmailSubject": null,
        "isExternalCustomerEnabled": false,
        "isReminderOn": false,
        "isReportsVisibleToHr": false,
        "location": [],
        "peerWeightage": null,
        "ratings": [],
        "reminderDate": [],
        "review360Name": this.createSurveyForm.value.review360Name,
        "review360Status": "Pending",
        "reviewCutoff": null,
        "selfWeightage": null,
        "stakeholders": [],
        "startDate": this.datePipe.transform(this.createSurveyForm.value.startDate, "yyyy-MM-dd"),
        "submissionEmailBody": null,
        "submissionEmailSubject": null,
        "subordinateWeightage": null,
        "superiorWeightage": null,
        "templateName": null,
        "toYear": test[1]
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.save360, request).
        subscribe((data: any) => {
          this.loader.dismissLoader()
          if (data?.status) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          }
        })
    }
  }


  addCommunicationRow(i: number, k: number): void {
    this.getCompetencyList[i].competencies.push(
      {
        competencyName: 'Other',
        questions: [{ question: '', questionType: 'Rating Based', id: null }]
      })
  }

  removeCommunicationRow(i: number, k: number): void {
    this.getCompetencyList[i].competencies.splice(-1, 1)
  }

  addQuestionRow(i: number, k: number): void {
    this.getCompetencyList[i].competencies[k].questions.push({ question: '', questionType: 'Rating Based', id: null })
  }

  removeQuestionRow(i: number, k: number, j: number): void {
    this.getCompetencyList[i].competencies[k].questions.splice(j, 1)
  }

  // AddBtn() {
  //   const successdialogRef = this.dialog.open(AddThreeSixtyReviewPopupComponent, {
  //     disableClose: true,
  //     height: '30%',
  //     width: '70%',
  //     data: {
  //       popupName: 'addPopup',
  //       selectedReviewID: this.selectedReviewID,
  //       reviewUserId: reviewUserId
  //     },
  //   });
  //   successdialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //      this.externalCustomerEmployeeIds = result.externalUser
  //     }
  //   });
  // }
  editExtUser(data: any, poupname: any) {
    
    const successdialogRef = this.dialog.open(AddThreeSixtyReviewPopupComponent, {
      disableClose: true,
      height: '30%',
      width: '70%',
      data: {
        popupName: poupname,
        selectedReviewID: this.selectedReviewID,
        data: data?.externaluserList,
        reviewUserId: data?.reviewUserId
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.stakeholderIdentificationArray?.forEach((ele: any) => {
          if (ele.reviewUserId == result?.reviewUserId) {
            ele.externaluserList = result.externalUser;
          }
        })
      }
    });
  }
  createArray() {
    this.stakeholderIdentificationArray = [];
    this.selectedEmployees?.forEach((ele: any) => {
      let obj = {
        reviewUserName: ele.firstName + ' ' + ele.lastName,
        reviewUserId: ele.id,
        stakeHolderSelfId: ele.id,
        stakeHolderSelfUserName: ele.firstName + ' ' + ele.lastName,
        superiorUserList: this.getAllEmployeeofCompany,
        subordinatesUserList: this.getAllEmployeeofCompany,
        peersUserList: this.getAllEmployeeofCompany,
        internalCutomerUserList: this.getAllEmployeeofCompany,
        selectedSuperiorUserList: this.getAllEmployeeofCompany,
        selectedSubordinatesUserList: this.getAllEmployeeofCompany,
        selectedPeersUserList: this.getAllEmployeeofCompany,
        selectedInternalCutomerUserList: this.getAllEmployeeofCompany,
        externaluserList: []
      }
      this.stakeholderIdentificationArray.push(obj)
    })
    if (this.stakeholdersArray.length != 0) {
      this.stakeholderIdentificationArray?.forEach((ele: any) => {
        this.stakeholdersArray?.forEach((ele1: any) => {
          if (ele.reviewUserId == ele1.userId) {
            ele.externaluserList = ele1.externalCustomerEmployeeIds;
            ele.selectedSuperiorUserList = ele1.superiorEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
            ele.selectedSubordinatesUserList = ele1.subordinateEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
            ele.selectedPeersUserList = ele1.peerEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
            ele.selectedInternalCutomerUserList = ele1.internalCustomerEmployeeIds.map((id: any) => this.getAllEmployeeofCompany.find((emp: any) => emp.id === id));
          }
        })
      })
    }

    console.log(this.stakeholderIdentificationArray)
  }
  getAllEmployeeofCompany: any = [];
  externalCustomerEmployeeIds: any = [];
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "search": null
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getAllEmployeeofCompany = [];
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
          }
          this.getAllEmployeeofCompany.push(obj);
        });
        this.createArray();
      }, (error: any) => {
      }, () => { });
  }
  stakeholdersArray: any = [];
  onClickSaveStakeholderIdentification(operation:any) {
    if(operation=='save'){
      if(this.isExternalCustomerEnabled){
        if(this.subordinateWeightage+this.superiorWeightage+this.selfWeightage+this.peerWeightage+this.externalCustomerWeightage+
        this.internalCustomerWeightage != 100){
          this.toastr.error('Total Weightage should be 100.', '', {
            timeOut: 3000,
          }); 
          return
        }
      }else{
        if(this.subordinateWeightage+this.superiorWeightage+this.selfWeightage+this.peerWeightage+
          this.internalCustomerWeightage != 100){
            this.toastr.error('Total Weightage should be 100.', '', {
              timeOut: 3000,
            }); 
            return
          } 
      }
    }

    this.stakeholdersArray = [];
    this.stakeholderIdentificationArray?.forEach((ele: any) => {
      let obj = {
        externalCustomerEmployeeIds: ele.externaluserList,
        id: null,
        internalCustomerEmployeeIds: ele?.selectedInternalCutomerUserList.map((ele: any) => ele.id),
        peerEmployeeIds: ele.selectedPeersUserList.map((ele: any) => ele.id),
        subordinateEmployeeIds: ele.selectedSubordinatesUserList.map((ele: any) => ele.id),
        superiorEmployeeIds: ele.selectedSuperiorUserList.map((ele: any) => ele.id),
        userId: ele.reviewUserId
      }
      this.stakeholdersArray.push(obj)
    })
    let data = {
      subordinateWeightage: this.subordinateWeightage,
      superiorWeightage: this.superiorWeightage,
      selfWeightage: this.selfWeightage,
      peerWeightage: this.peerWeightage,
      externalCustomerWeightage: this.externalCustomerWeightage,
      internalCustomerWeightage: this.internalCustomerWeightage,
      stakeholdersArray: this.stakeholdersArray
    }
    this.dialogRef.close(data);
  }
  getCompetencyFor360() {
    const test = this.selectedYear?.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": test[0],
      "search": null,
      "toYear": test[1],
      "userIds": this.selectedEmployees.map((ele: any) => ele.id),
    }
    this.httpService.callPostService(this.config.getCompetencyFor360, request)
      .subscribe((data: any) => {
        this.getCompetencyList = []
        data?.data?.forEach((ele: any) => {
          let obj = {
            band: ele.band,
            department: ele.functionName,
            competencies: ele.competencyMasterlist?.map((ele1: any) => ({
              competencyName: ele1.competencyName,
              questions: [{ question: '', questionType: 'Rating Based', id: null }]
            })) || [],
          }
          this.getCompetencyList.push(obj)
        })
      }, (error: any) => {
      }, () => { });
  }
  onClickSaveQuestion(operation:any) {
    if(operation=='save'){
      if (this.getCompetencyList.some((item: any) =>
        item.competencies.some((competency: any) =>
          competency.questions.some((q: any) => q.question === '')
        )
      )) {
        this.toastr.error('Please fill all mandetory fields.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    let data = {
      getCompetencyList: this.getCompetencyList
    }
    this.dialogRef.close(data);
  }
}
